export default [
  {
    id:'1',
    slug:'commend',
    name:'首页推荐',
    created_at:'2020-11-26 15:43',
  },
  {
    id:'2',
    slug:'inslide',
    name:'幻灯展示',
    created_at:'2020-11-25 10:30',
  },
  {
    id:'3',
    slug:'channel-feathure',
    name:'频道推荐',
    created_at:'2020-11-24 10:30',
  },

  {
    id:'4',
    slug:'attr-1',
    name:'属性1',
    created_at:'2020-11-20 10:30',
  },

  {
    id:'5',
    slug:'attr-2',
    name:'属性2',
    created_at:'2020-11-20 10:30',
  },


]